import type { JiraSettingsState } from '@atlassian/jira-issue-shared-types/src/common/types/jira-settings-type.tsx';
import type { StoreApi } from './types.tsx';

export const setJiraSettings =
	(jiraSettings: JiraSettingsState) =>
	({ setState }: StoreApi) => {
		setState(jiraSettings);
	};
